import "./client.svelte.js"		// importing order client, core
import "./pinch-zoom.js"        // import web component pinch-zoom
import "../static/pentelion.sass"
import App from './App.svelte';
import { mount } from "svelte";

const app = mount(App, {
	target: document.body,
	props: { }
});

export default app;